"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm from "@/components/form/UiForm.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v1/web-resource-elements")
);
let XPathDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.gridController = _gridController;
    this.webpageResourceId = "";
    this.xpathNum = 0;
    this.canDelete = true;
    this.empty_image = emptyImage;
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.pagePosition = "dialog";
    });
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        console.log(data);
        if (data.type === "system") {
          this.canDelete = false;
        } else {
          this.canDelete = true;
        }
        this.webpageResourceId = data.id;
        this.xpathNum = data.xpathNum;
        if (this.xpathNum > 0) {
          this.gridController.query.filter = `webpageResourceId == ${data.id}`;
          yield this.gridController.search();
        }
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  deleteElement(item) {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.auth/api/v1/web-resource-elements/${item.id}`);
        this.xpathNum = this.xpathNum - 1;
        yield this.gridController.search();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
XPathDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit,
      UiGrid
    }
  })
], XPathDialog);
export {
  XPathDialog as default
};
